let coursePlans = document.querySelectorAll(".course-plan");

// if the course plans are not loaded yet, wait a bit and try again
if (coursePlans.length > 0) {
    loadCoursePlans(coursePlans);
} else {
    setTimeout(() => {
        coursePlans = document.querySelectorAll(".course-plan");
        if (coursePlans.length > 0) {
            loadCoursePlans(coursePlans);
        } else {
            setTimeout(() => {
                coursePlans = document.querySelectorAll(".course-plan");
                loadCoursePlans(coursePlans);
                if (coursePlans.length === 0) {
                    console.warn("Couldn't find course plan elements.");
                }
            }, 400);
        }
    }, 100);
}

function loadCoursePlans(coursePlanEls) {
    coursePlanEls.forEach((coursePlanEl) => {
        //SETUP

        const calendarEl = coursePlanEl.querySelector("#cpCalendar");

        const type = calendarEl.dataset.type;
        const fixedHolidays = ["01-01", "01-06", "05-01", "08-15", "10-26", "11-01", "12-08", "12-25", "12-26"];
        let holidays = [];
        let startData = {};
        let intensiveSummer = {};
        let intensiveWinter = [];
        let extra = [];
        const states = new Map();

        const startPrefix = "Start: ";
        const region = "de-AT";
        const startDateFormat = { year: "numeric", month: "2-digit", day: "2-digit" };
        const start2WeeksEl = coursePlanEl.querySelector("#cpStart2Weeks");
        const start3WeeksEl = coursePlanEl.querySelector("#cpStart3Weeks");
        const startSpecialEl = coursePlanEl.querySelector("#cpStartSpecial");
        const startEnglishEl = coursePlanEl.querySelector("#cpStartEnglish");

        const timesSpecialEl = coursePlanEl.querySelector("#cpTimesSpecial");
        const timesEnglishEl = coursePlanEl.querySelector("#cpTimesEnglish");
        const timesC95D95El = coursePlanEl.querySelector("#cpTimesC95D95");

        const dayEls = calendarEl.querySelectorAll(".course-plan__calendar-day");
        const prevMonthEl = calendarEl.querySelector(".course-plan__calendar-selection-previous");
        const currentMonthEl = calendarEl.querySelector(".course-plan__calendar-selection-current");
        const nextMonthEl = calendarEl.querySelector(".course-plan__calendar-selection-next");

        // INFORMATION RETRIEVAL

        try {
            if (calendarEl.dataset.start) {
                startData = JSON.parse(calendarEl.dataset.start);
            }
            if (calendarEl.dataset.intensiveSummer) {
                intensiveSummer = JSON.parse(calendarEl.dataset.intensiveSummer);
            }
            if (calendarEl.dataset.intensiveWinter) {
                intensiveWinter = JSON.parse(calendarEl.dataset.intensiveWinter);
            }
            if (calendarEl.dataset.extra) {
                extra = JSON.parse(calendarEl.dataset.extra);
            }
            if (calendarEl.dataset.holidays) {
                holidays = JSON.parse(calendarEl.dataset.holidays);
            }
        } catch (e) {
            console.error(e);
        }

        if (dayEls && dayEls.length === 42 && prevMonthEl && currentMonthEl && nextMonthEl) {
            // GENERATE STATES

            if (Object.values(startData).length > 0) {
                if (type === "b") {
                    addStates("2weeks", [0, 1, 2, 3, 4, 7, 8, 9]);
                    addStates("3weeks", [0, 1, 2, 3, 7, 8, 9, 10, 14, 15, 16, 17]);
                    addStates("english", [0, 1, 2, 3, 7, 8, 9, 10]);
                } else if (type === "d") {
                    addStates("special", [0, 1, 2]);
                } else if (type === "c") {
                    addStates("2weeks", [0, 1, 3]);
                    addStates("special", [0, 1]);
                } else {
                    addStates("special", [0]);

                    if (type === "a") {
                        addStates("english", [0]);
                    }
                }
            }

            if (Object.values(intensiveSummer).length > 0) {
                addStates("intensiveSummer", [0, 1, 2, 3, 4, 7, 8, 9]);
            }

            if (intensiveWinter.length > 0) {
                addStates("intensiveWinter", intensiveWinter);
            }

            for (let i = 0; i < extra.length; i++) {
                const extraData = extra[i];

                if (type === "b") {
                    if (extraData.mode === "2weeks") {
                        addStates("extra_2weeks", [0, 1, 2, 3, 4, 7, 8, 9], extraData.date);
                    } else if (extraData.mode === "3weeks") {
                        addStates("extra_3weeks", [0, 1, 2, 3, 7, 8, 9, 10, 14, 15, 16, 17], extraData.date);
                    }
                } else if (type === "c") {
                    if (extraData.mode === "2weeks") {
                        addStates("extra_2weeks", [0, 1, 3], extraData.date);
                    } else if (extraData.mode === "special") {
                        addStates("extra_special", [0, 1], extraData.date);
                    }
                } else if (type === "d") {
                    addStates("extra_special", [0, 1, 2], extraData.date);
                } else if (extraData.mode === "special") {
                    addStates("extra_special", [0], extraData.date);
                }
            }

            // CALENDAR FUNCTIONALITY

            const today = new Date();
            let year = today.getFullYear();
            let month = today.getMonth();

            fillCalendar(today.getMonth(), today.getFullYear());

            prevMonthEl.addEventListener("click", () => {
                month--;
                if (month < 0) {
                    month = 11;
                    year--;
                }
                fillCalendar(month, year);
            });

            nextMonthEl.addEventListener("click", () => {
                month++;
                if (month > 11) {
                    month = 0;
                    year++;
                }
                fillCalendar(month, year);
            });

            // FUNCTIONS

            function addStates(mode, schema, startDate = null) {
                // schema is an array of days after the start date

                if (mode === "intensiveWinter") {
                    for (let i = 0; i < schema.length; i++) {
                        const dayISO = schema[i];

                        if (states.has(dayISO)) {
                            states.get(dayISO).push(mode);
                        } else {
                            states.set(dayISO, [mode]);
                        }
                    }
                    return;
                }

                if (mode.startsWith("extra") && startDate) {
                    mode = mode.substring(6);

                    for (let i = 0; i < schema.length; i++) {
                        const day = new Date(startDate);
                        day.setDate(day.getDate() + schema[i]);

                        if (isHoliday(day)) {
                            if (mode === "2weeks") {
                                if (type === "c") {
                                    day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                                } else {
                                    day.setDate(day.getDate() + ((6 + 7 - day.getDay()) % 7));
                                }
                            } else if (mode === "3weeks") {
                                day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                            } else if (type === "d" && mode === "special") {
                                day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                            }
                        }

                        const dayISO = toISODateString(day);

                        if (states.has(dayISO)) {
                            states.get(dayISO).push(mode);
                        } else {
                            states.set(dayISO, [mode]);
                        }
                    }
                    return;
                }

                for (let m = 0; m < 12; m++) {
                    let startDate;

                    switch (mode) {
                        case "2weeks":
                            startDate = startData[m]?.start2Weeks;
                            break;
                        case "3weeks":
                            startDate = startData[m]?.start3Weeks;
                            break;
                        case "special":
                            startDate = startData[m]?.startSpecial;
                            break;
                        case "english":
                            startDate = startData[m]?.startEnglish;
                            break;
                        case "intensiveSummer":
                            startDate = intensiveSummer.startIntensive;
                            break;
                    }

                    if (!startDate || new Date(startDate).getMonth() !== m) {
                        continue;
                    }

                    for (let i = 0; i < schema.length; i++) {
                        const day = new Date(startDate);
                        day.setDate(day.getDate() + schema[i]);

                        if (isHoliday(day)) {
                            if (mode === "2weeks") {
                                if (type === "c") {
                                    day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                                } else {
                                    day.setDate(day.getDate() + ((6 + 7 - day.getDay()) % 7));
                                }
                            } else if (mode === "3weeks") {
                                day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                            } else if (type === "d" && mode === "special") {
                                day.setDate(day.getDate() + ((5 + 7 - day.getDay()) % 7));
                            }
                        }

                        const dayISO = toISODateString(day);

                        if (states.has(dayISO)) {
                            states.get(dayISO).push(mode);
                        } else {
                            states.set(dayISO, [mode]);
                        }
                    }
                }
            }

            function fillCalendar(month, year) {
                const firstMonthDay = new Date(year, month, 1);
                const firstDayWeekday = new Date(year, month, 1).getDay();
                const firstShownDay = new Date(year, month, 1 + (firstDayWeekday === 0 ? -6 : 1 - firstDayWeekday));
                const lastMonthDay = new Date(year, month + 1, 0);
                const lastShownDay = new Date(year, month, lastMonthDay.getDate() + ((7 - lastMonthDay.getDay()) % 7));

                if (Object.values(startData).length > 0) {
                    setStartDates();
                }
                resetTimes();

                currentMonthEl.innerText = firstMonthDay.toLocaleDateString(region, {
                    year: "numeric",
                    month: "long",
                });

                dayEls.forEach((dayEl, index) => {
                    const date = new Date(
                        firstShownDay.getFullYear(),
                        firstShownDay.getMonth(),
                        firstShownDay.getDate() + index
                    );
                    const dateISO = toISODateString(date);
                    const dateStates = states.get(dateISO) ?? [];

                    const textEl = dayEl.querySelector(".course-plan__calendar-day-text");
                    const state2WeeksEl = dayEl.querySelector(".course-plan__calendar-day-state--2weeks");
                    const state3WeeksEl = dayEl.querySelector(".course-plan__calendar-day-state--3weeks");
                    const stateSpecialEl = dayEl.querySelector(".course-plan__calendar-day-state--special");
                    const stateEnglishEl = dayEl.querySelector(".course-plan__calendar-day-state--english");
                    const stateEls = [state2WeeksEl, state3WeeksEl, stateSpecialEl, stateEnglishEl];

                    // reset days
                    stateEls.forEach((stateEl) => {
                        stateEl?.classList?.remove("course-plan__calendar-day-state--active");
                    });
                    dayEl.classList.remove("course-plan__calendar-day--other-month");
                    dayEl.classList.remove("course-plan__calendar-day--holiday");
                    textEl.innerText = "";

                    if (date.getTime() <= lastShownDay.getTime()) {
                        textEl.innerText = date.getDate();
                    }

                    if (date.getTime() < firstMonthDay.getTime() || date.getTime() > lastMonthDay.getTime()) {
                        dayEl.classList.add("course-plan__calendar-day--other-month");
                    }

                    if (isHoliday(date)) {
                        dayEl.classList.add("course-plan__calendar-day--holiday");
                    }

                    // don't fill day elements that are not in the shown date range
                    if (date.getTime() < firstShownDay.getTime() || date.getTime() > lastShownDay.getTime()) {
                        return;
                    }

                    if (dateStates.includes("holiday")) {
                        dayEl.classList.add("course-plan__calendar-day--other-month");
                    }

                    if (dateStates.includes("2weeks")) {
                        state2WeeksEl.classList.add("course-plan__calendar-day-state--active");

                        if (timesC95D95El) {
                            timesC95D95El.style.display = "block";
                        }
                    }

                    if (dateStates.includes("3weeks")) {
                        state3WeeksEl.classList.add("course-plan__calendar-day-state--active");
                    }

                    if (
                        dateStates.includes("special") ||
                        dateStates.includes("intensiveSummer") ||
                        dateStates.includes("intensiveWinter")
                    ) {
                        stateSpecialEl.classList.add("course-plan__calendar-day-state--active");

                        if (timesSpecialEl) {
                            timesSpecialEl.style.display = "block";
                        }

                        if (timesC95D95El) {
                            timesC95D95El.style.display = "block";
                        }
                    }

                    if (dateStates.includes("english")) {
                        stateEnglishEl.classList.add("course-plan__calendar-day-state--active");

                        if (timesEnglishEl) {
                            timesEnglishEl.style.display = "block";
                        }
                    }
                });
            }

            function isHoliday(date) {
                const dateInHolidayFormat = toISODateString(date).substring(5);

                return holidays.includes(toISODateString(date)) || fixedHolidays.includes(dateInHolidayFormat);
            }

            function resetTimes() {
                if (timesSpecialEl && (type === "b" || type === "c")) {
                    timesSpecialEl.style.display = "none";
                }

                if (timesEnglishEl) {
                    timesEnglishEl.style.display = "none";
                }
            }

            function setStartDates() {
                if (start2WeeksEl) {
                    const start2Weeks = startData[month]?.start2Weeks ? new Date(startData[month]?.start2Weeks) : null;
                    if (start2Weeks && start2Weeks.getFullYear() === year) {
                        if (isHoliday(start2Weeks)) {
                            start2Weeks.setDate(start2Weeks.getDate() + 1);
                        }
                        start2WeeksEl.innerText = startPrefix + start2Weeks.toLocaleDateString(region, startDateFormat);
                    } else {
                        start2WeeksEl.innerText = "";
                    }
                    setExtraStartDates(start2WeeksEl, "2weeks");
                }

                if (start3WeeksEl) {
                    const start3Weeks = startData[month]?.start3Weeks ? new Date(startData[month]?.start3Weeks) : null;
                    if (start3Weeks && start3Weeks.getFullYear() === year) {
                        if (isHoliday(start3Weeks)) {
                            start3Weeks.setDate(start3Weeks.getDate() + 1);
                        }
                        start3WeeksEl.innerText = startPrefix + start3Weeks.toLocaleDateString(region, startDateFormat);
                    } else {
                        start3WeeksEl.innerText = "";
                    }
                    setExtraStartDates(start3WeeksEl, "3weeks");
                }

                if (startSpecialEl) {
                    let startSpecial = null;
                    if (type === "b") {
                        const startIntensiveSummer = intensiveSummer.startIntensive
                            ? new Date(intensiveSummer.startIntensive)
                            : null;
                        const startIntensiveWinter = intensiveWinter.at(0) ? new Date(intensiveWinter.at(0)) : null;

                        if (startIntensiveSummer && startIntensiveSummer.getMonth() === month) {
                            startSpecial = startIntensiveSummer;
                        } else if (startIntensiveWinter && startIntensiveWinter.getMonth() === month) {
                            startSpecial = startIntensiveWinter;
                        }
                    } else {
                        startSpecial = startData[month]?.startSpecial ? new Date(startData[month]?.startSpecial) : null;
                    }

                    if (startSpecial && startSpecial.getFullYear() === year) {
                        if (isHoliday(startSpecial)) {
                            startSpecial.setDate(startSpecial.getDate() + 1);
                        }
                        startSpecialEl.innerText =
                            startPrefix + startSpecial.toLocaleDateString(region, startDateFormat);
                    } else {
                        startSpecialEl.innerText = "";
                    }
                    setExtraStartDates(startSpecialEl, "special");
                }

                if (startEnglishEl) {
                    const startEnglish = startData[month]?.startEnglish
                        ? new Date(startData[month]?.startEnglish)
                        : null;
                    if (startEnglish && startEnglish.getFullYear() === year) {
                        startEnglishEl.innerText =
                            startPrefix + startEnglish.toLocaleDateString(region, startDateFormat);
                    } else {
                        startEnglishEl.innerText = "";
                    }
                }
            }

            function setExtraStartDates(elem, mode) {
                extra.forEach((extraData) => {
                    const extraDate = new Date(extraData.date);
                    if (isHoliday(extraDate)) {
                        extraDate.setDate(extraDate.getDate() + 1);
                    }
                    if (extraData.mode === mode && extraDate.getMonth() === month && extraDate.getFullYear() === year) {
                        if (elem.innerText === "") {
                            elem.innerText = startPrefix + extraDate.toLocaleDateString(region, startDateFormat);
                        } else {
                            elem.innerText += ", " + extraDate.toLocaleDateString(region, startDateFormat);
                        }
                    }
                });
            }

            function toISODateString(date) {
                return `${date.getFullYear()}-${(date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
            }
        }
    });
}
